import { datadogLogs } from '@datadog/browser-logs';
import { DataDogBrowserLogsTransport } from '@loglayer/transport-datadog-browser-logs';
import { ConsoleTransport, LogLayer, LogLevelType } from 'loglayer';

// Environment configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isTest =
  process.env.NODE_ENV === 'test' || process.env.NEXT_PUBLIC_CYPRESS_TEST_ENV;

// Log level configuration
const getLogLevel = () => {
  if (isTest) return 'error'; // Only errors in tests
  if (isDevelopment) return 'debug'; // All logs in development
  return process.env.NEXT_PUBLIC_LOG_LEVEL || 'info'; // Configurable in production
};

const createLogger = () => {
  return new LogLayer({
    transport: [
      new ConsoleTransport({
        logger: console,
        enabled: process.env.NODE_ENV !== 'production',
        level: getLogLevel() as LogLevelType,
      }),
      new DataDogBrowserLogsTransport({
        logger: datadogLogs.logger,
        enabled: process.env.NODE_ENV === 'production',
        level: getLogLevel() as LogLevelType,
      }),
    ],
  });
};

// Create logger instance
export const logger = createLogger();
